import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    TABLET_WIDTH,
} from '../../constant';
import useWindowDimensions from '../../hooks/useWindowDimension';
import { preferencesStorageInstance as preferencesStorage } from '../../services/preferencesStorage';
import PreferencesListItemGroups from './PreferencesListItemGroups';
import { useOnScreen } from '../../hooks/useOnScreen';
import Checkbox from "../Checkbox";
import PreferencesListEditPreference from "./PreferencesListEditPreference";
import {createPreferenceItemCodesValue, findFrequencyTitle} from "./util";

const PreferencesListItem = ({preference}) => {
    const { i18n } = useTranslation();
    const [isChecked, setIsChecked] = useState(false);
    const [phrasesCount, setPhrasesCount] = useState(0);
    const { width } = useWindowDimensions();
    const ref = useRef(null);
    const isVisible = useOnScreen(ref);
    const navigate = useNavigate();

    const changeSelectedList = (checked) => {
        setIsChecked(checked);
        preferencesStorage.selectPreference(preference.id, checked);
    };

    useEffect(() => {
        preferencesStorage.getPreferencePhrasesCount(preference.id, (response) => setPhrasesCount(response.count));
    }, [isVisible]);

    return (
        <>
            <li className="preference__list-item" ref={ref}>
                <Checkbox checked={isChecked} handleChecked={changeSelectedList} />
                <ul className="preference__item-row">
                    <li className="preference__item">
                        <span className="preference__item-header">{i18n.t('app.page.preference.addTitles.include')}</span>
                        <span className="preference__item-content">{i18n.t(`preference.scheme.include.${preference.include}`)}</span>
                    </li>
                    <li className="preference__item">
                        <span className="preference__item-header">{i18n.t('app.page.preference.addTitles.preferenceType')}</span>
                        <span className="preference__item-content">{i18n.t(`preference.scheme.preferenceType.${preference.preferenceType}`)}</span>
                    </li>
                    <li className="preference__item">
                        <span className="preference__item-header">{i18n.t('app.page.preference.addTitles.preferenceItemCode')}</span>
                        <span className="preference__item-content">{createPreferenceItemCodesValue(preference, i18n)}</span>
                    </li>
                    {width <= TABLET_WIDTH ? 
                        null 
                        :  
                        <li className="preference__item">
                            <span className="preference__item-header">{i18n.t('app.page.preference.addTitles.when')}</span>
                            <span className="preference__item-content">{i18n.t(`preference.scheme.when.${preference.when}`)}</span>
                        </li>
                    }
                    {width <= TABLET_WIDTH ? 
                        null 
                        :  
                        <li className="preference__item">
                            <span className="preference__item-header">{i18n.t('app.page.preference.addTitles.howOften')}</span>
                            <span className="preference__item-content">{findFrequencyTitle(preference.preferenceFrequency, +preference.frequencyPeriod, i18n)}</span>
                        </li>
                    }
                </ul>
                <div className="preference__item-icons">
                    <PreferencesListItemGroups preferenceId={preference.id} />
                    <PreferencesListEditPreference preferenceId={preference.id} />
                    <p className="preference__item-count" onClick={() => navigate(preferencesStorage.getPathForPhrasesPage(preference))}>
                        <span className="preference__item-quantity">{phrasesCount}</span>
                    </p>
                </div>
            </li>
        </>
    );
};

export default PreferencesListItem;
